module.exports = __webpack_public_path__ + "static/media/youtube.4f3d6664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/youtube.svg
// module id = 357
// module chunks = 1